config = TAPAS_ENV

EnvironmentService = Em.Service.extend Em.merge(config, {
  isTest:        Em.computed.equal('name', 'test')
  isDevelopment: Em.computed.equal('name', 'development')
  isProduction:  Em.computed.equal('name', 'production')

  mergeFeatures: (features={}) ->
    for k, v of features
      Em.set(@, "features.#{k.camelize()}", v)

  ###
  # Хелпер-метод для форматирования цены
  ###
  translate_currency: (price, options={}) ->
    try
      options.precision = 2 if price && parseInt(price) != price
      options =
        symbol:    options.unit
        precision: (options.precision || 0)
        decimal:   options.separator
        thousand:  options.delimiter
        format:    (options.format || '').replace('%u', '%s').replace('%n', '%v')

      formatted = accounting.formatMoney(price, options)
    catch e
      formatted = @translate('currency', { price })

  translate_billing_currency: (price, precision=0) ->
    @translate('currency', { price })

  has_translation_for: (translation) ->
    try Em.I18n.exists(translation); catch e then false

  ###
  # Хелпер-метод для вызова Ember I18n
  ###
  translate: (translation, props...) ->
    try Em.I18n.t(translation, props...); catch e then ''
})

module.exports = EnvironmentService
